import { COULEURS_MARKER } from '@/services/gestionIconMarker/iconMarkerConf';

/**
 * Convertit un hex (#RRGGBB ou #RGB) en { r, g, b }
 */
function hexToRgb(hex) {
  let h = hex.replace(/^#/, '');

  // Supporte le format court #RGB → #RRGGBB
  if (h.length === 3) {
    h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
  }

  if (h.length !== 6) {
    throw new Error(`Couleur hex invalide : "${hex}"`);
  }

  return {
    r: parseInt(h.slice(0, 2), 16),
    g: parseInt(h.slice(2, 4), 16),
    b: parseInt(h.slice(4, 6), 16),
  };
}

/**
 * Distance euclidienne au carré entre deux couleurs RGB.
 * (On évite Math.sqrt inutile puisqu'on compare uniquement les distances.)
 */
function colorDistanceSq(a, b) {
  return (
    (a.r - b.r) ** 2 +
    (a.g - b.g) ** 2 +
    (a.b - b.b) ** 2
  );
}

/**
 * Retourne la couleur de COULEURS_MARKER la plus proche de `inputHex`.
 *
 * @param {string} inputHex  - Ex: "#AB149E" ou "#a4f"
 * @returns {{ hex: string, id: number }}
 *   - hex : la couleur la plus proche (ex: "#ab149e")
 *   - id  : son identifiant dans COULEURS_MARKER
 */
export function closestMarkerColor(inputHex) {
  const input = hexToRgb(inputHex);

  let bestHex  = null;
  let bestId   = null;
  let bestDist = Infinity;

  for (const [hex, id] of Object.entries(COULEURS_MARKER)) {
    const dist = colorDistanceSq(input, hexToRgb(hex));

    if (dist < bestDist) {
      bestDist = dist;
      bestHex  = hex;
      bestId   = id;
    }

    // Correspondance exacte → pas besoin de continuer
    if (dist === 0) break;
  }

  return { hex: bestHex, id: bestId };
}
